import { useLocation } from 'react-router-dom'

export const useChatChannelSid = (): string => {
	const location = useLocation()

	return location?.pathname.match(/\w+$/g)?.[0] || ''
}
